import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  DaterangeModule,
  InlineEditModule,
  NfFormsModule,
  ToastModule,
  ToggleModule,
} from '@northfork/ng-basics'
import { AccountSummaryComponent } from './account-summary/account-summary.component'
import { AccountsDialogComponent } from './accounts-dialog/accounts-dialog.component'
import { CorporateActionsAdvancedOptionsComponent } from './corporate-actions-advanced-options/corporate-actions-advanced-options.component'
import { BulkEntryDialogComponent } from './corporate-actions-create-edit/bulk-entry-dialog/bulk-entry-dialog.component'
import { CorporateActionsCreateEditComponent } from './corporate-actions-create-edit/corporate-actions-create-edit.component'
import { CorporateActionsDeleteConfirmationModal } from './corporate-actions-create-edit/corporate-actions-delete-confirmation-modal'
import { CorporateActionSaveConfirmationModal } from './corporate-actions-create-edit/corporate-actions-save-confirmation-modal'
import { CorporateActionsDetailsComponent } from './corporate-actions-details/corporate-actions-details.component'
import { CorporateActionsGridComponent } from './corporate-actions-grid/corporate-actions-grid.component'
import { CorporateActionsPanelComponent } from './corporate-actions-panel.component'
import { CorporateActionsProcessingComponent } from './corporate-actions-processing/corporate-actions-processing.component'
import { ProcessingSubmitConfirmationModal } from './corporate-actions-processing/processing-submit-confirmation-modal'
import { IceCorporateActionsGridComponent } from './ice-corporate-actions-grid/ice-corporate-actions-grid.component'
import { IceCorporateActionDetailComponent } from './ice-corporate-action-detail/ice-corporate-action-detail.component'
@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    GenericComponentsModule,
    NgbModalModule,
    NgbTooltipModule,
    NgbNavModule,
    NfFormsModule,
    FormsModule,
    DaterangeModule,
    ResizeHandleModule,
    NgbAccordionModule,

    NgbDropdownModule,
    NgSelectModule,

    InlineEditModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Northfork Dependencies
    InlineEditModule,
    ToastModule,
    ToggleModule,
  ],
  declarations: [
    CorporateActionsPanelComponent,
    CorporateActionsDetailsComponent,
    CorporateActionsGridComponent,
    AccountsDialogComponent,
    CorporateActionsCreateEditComponent,
    AccountSummaryComponent,
    CorporateActionSaveConfirmationModal,
    CorporateActionsDeleteConfirmationModal,
    BulkEntryDialogComponent,
    CorporateActionsAdvancedOptionsComponent,
    IceCorporateActionsGridComponent,
    IceCorporateActionDetailComponent,
    CorporateActionsProcessingComponent,
    ProcessingSubmitConfirmationModal,
  ],
  exports: [CorporateActionsPanelComponent],
})
export class CorporateActionsModule {}

export { CorporateActionsPanelComponent }
